var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBinder2Rings = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.29 54.2h-8.58V24.85h8.58V54.2Zm-7.6-1h6.62V25.82h-6.62V53.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m68 58.84-16.69-4.72V24.83L68 21.2v37.64Zm-15.71-5.46L67 57.55V22.41l-14.71 3.21v27.76ZM28 58.84V21.2l16.69 3.63v29.29L28 58.84Zm1-36.43v35.14l14.73-4.17V25.62L29 22.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.09 49.06c-1.07.07-2.14-.24-3-.89-.31-.3-.91-1.15.2-2.38l.14-.16h5.33l.15.17c1.07 1.26.43 2.1.11 2.4-.85.61-1.88.91-2.93.86Zm-2.19-2.45c-.43.55-.21.77-.11.87.82.8 3.73.8 4.58 0 .11-.1.35-.32 0-.87H45.9ZM50.71 31.4h-5.26l-.14-.16c-1.1-1.24-.5-2.08-.18-2.39 1.17-1.14 4.59-1.16 5.82 0 .32.3 1 1.14-.1 2.4l-.14.15Zm-4.81-1h4.34c.4-.56.15-.79 0-.89-.83-.77-3.68-.77-4.47 0-.07.14-.29.36.13.92v-.03Z"
  })));
};
export default SvgBinder2Rings;